import React, { useState, useContext, useEffect } from "react";
import Navbar from "../components/Navbar";
import ProfileSquelette from "../layouts/ProfileSquelette";
import ProfileHead from "../components/ProfileHead";
import { useParams, useNavigate } from "react-router-dom";
import { env } from "../datas.config";
import { AuthContext } from "../contexts/AuthContext";
import Spinner from "../components/Spinner";
import ChatBot from "../components/chat/Chatbot";
import { DisplayDiscussionForMiniScreenProvider } from "../contexts/DisplayDiscussionForMiniScreenContext";

export default function ContactPage() {
  const { username } = useParams();
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const [contact, setContact] = useState(null);
  const [display, setDisplay] = useState(true);
  useEffect(() => {
    (async function fetchUserInfo() {
      try {
        const res = await fetch(`${env.domain}/api/auth/user/${username}`, {
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
        });
        const result = await res.json();
        if (result.status !== 200 || !result.result) {
          navigate("/*");
          return;
        }
        setContact(result.result);
      } catch (erreur) {
        console.error(erreur);
        navigate("/*");
        return;
      } finally {
        setTimeout(() => {
          setDisplay(false);
        }, 1000);
      }
    })();
  }, [username, navigate]);
  return (
    <>
      {display ? (
        <Spinner visibility={display} />
      ) : contact ? (
        <>
          <DisplayDiscussionForMiniScreenProvider>
            <Navbar />
            <ProfileSquelette>
              <ProfileHead
                image={contact.userImage}
                nom={contact.nom}
                prenom={contact.prenom}
                poste={contact.poste}
                username={contact.username}
                userId={contact.userId}
                colors={contact.color}
              />
            </ProfileSquelette>
            <ChatBot />
          </DisplayDiscussionForMiniScreenProvider>
        </>
      ) : null}
    </>
  );
}
